<template>
  <div class="flex-box mine-view">
    <div class="bg-w card-shadow left-nav" style="min-height: calc(100vh - 100px);">

      <div class="left-nav-link" :class="$route.path == item.path ? 'active' : ''"
           v-for="(item, index) in routerList" :key="index"
           @click="linkView(item)">
        <div class="left-nav-link-inner">
          <i :class="item.icon" style="margin-right: 25px"></i>{{ item.label }}
        </div>
      </div>
      <!--<router-link class="flex-box al-c cu-p side-bar-item" v-for="(item, index) in routerList" :key="index" :to="item.path">-->
        <!--<i :class="item.icon"></i>-->
        <!--<span class="ml10 flex-1 ellipsis">{{ item.label }}</span>-->
      <!--</router-link>-->
    </div>

    <div class="card-shadow bg-w right-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Mine",
  components: {},
  props: [],
  data() {
    return {
      routerList: [
        {
          label: "个人信息",
          icon: "myfont icon-zhanghao",
          path: "/mine/userData"
        },

          {
              label: "我的事务",
              icon: "myfont icon-zuhe",
              path: "/mine/myAffair"
          },
        {
          label: "消息中心",
          icon: "el-icon-chat-dot-round ",
          path: "/mine/message"
        },
          {
              label: "我的收藏",
              icon: "el-icon-shopping-bag-1",
              path: "/mine/collect"
          } ,
          {
              label: "我的留言",
              icon: "myfont icon-youxiang",
              path: "/mine/voiceMessage"
          },
        // {
        //   label: "自定义服务",
        //   icon: "myfont icon-zuhe",
        //   path: "/mine/customized"
        // },
        {
          label: "我的建议",
          icon: "myfont icon-liuyan",
          path: "/mine/suggest"
        },

         {
              label: "账号安全",
              icon: "myfont icon-zhanghaomima",
              path: "/mine/passwordEdit"
          }

        // {
        //   label: "日程信息",
        //   icon: "myfont icon-rili",
        //   path: "/mine/schedule"
        // }
      ]
    };
  },
  computed: {
    ...mapGetters(["userData"])
  },
  created() {
    this.addViewRouter();
  },
  mounted() {
    // this.$router.push(this.routerList[0].path)
  },
  destroyed() {},
  methods: {
      linkView(item){
          this.$router.push({path:item.path})

      },
    addViewRouter() {
      this.routerList = this.routerList.filter(
        val => this.userData.routerData.indexOf(val.path) > -1
      );
    }
  },
  watch: {

  },
  filters: {}
};
</script>

<style scoped lang="less">
.mine-view {
  max-width: 1200px;
  margin: 20px auto 0 auto;
  .right-content{
    width: 950px;
  }
  .left-nav {
    margin-right: 20px;
    padding: 12px 0;
    width: 214px;
    background: #fff;
    margin-left: 10px;

    &-link {
      margin: 10px 0;
      position: relative;

      &-inner{
        height: 50px;
        font-size: 16px;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        width: 200px;
        left: 21px;
        text-align: left;
        padding-left: 25px;
        border-bottom-left-radius: 50px;
        border-top-left-radius: 50px;
        position: relative;

      }
      &.active {
        .left-nav-link-inner{
          color: #ffffff;
          // background: rgba(73, 164, 240, 1);
          z-index: 1;
        }

        // &:after {
        //   content: '';
        //   display: block;
        //   width: 0;
        //   height: 0;
        //   border: 8px solid transparent;
        //   position: absolute;
        //   bottom: -8px;
        //   z-index: 0;
        //   border-left: 8px solid #3E86A0;
        //   right: -15px;
        // }
      }
    }
  }

}


</style>
